import React from 'react';
import { compose, withHandlers } from 'recompose';
import { reduxForm, Field, FormSection } from 'redux-form';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField, Select } from 'redux-form-material-ui';
import Grid from '@material-ui/core/Grid';
import { get } from 'lodash';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { Link } from 'react-router-dom';

const required = (value) => (value || typeof value === 'number' ? undefined : 'Vyžadováno');
const email = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Neplatný formát emailu'
    : undefined;
const number = (value) => (value && isNaN(Number(value)) ? 'Musí být číslo' : undefined);
const maxLength = (max) => (value) =>
  value && value.length > max ? `Je povoleno maximálně ${max} znaků` : undefined;
const maxLengt16 = maxLength(16);
const maxLength32 = maxLength(32);
const maxLength64 = maxLength(64);
const maxLength256 = maxLength(256);

const styles = (theme) => ({
  section: {
    marginBottom: 25,
  },
  textFields: {
    width: '80%',
  },
  buttons: {
    margin: '0 5px',
  },
});

const enhance = compose(
  withStyles(styles),
  connect(
    (state) => ({
      userAttributes: get(state, 'app.userAttributes', []),
    }),
    null
  ),
  withHandlers({}),
  reduxForm({ form: 'userForm' })
);

export default enhance(({ classes, handleSubmit, setEdit, userAttributes, action }) => (
  <form className={classes.form} onSubmit={handleSubmit}>
    <FormSection name="userInfo">
      <div className={classes.section}>
        <Grid container spacing={8}>
          <Grid item xs={3}>
            <Field
              name="surname"
              component={TextField}
              label="Příjmení"
              className={classes.textFields}
              validate={[required, maxLength64]}
            />
          </Grid>
          <Grid item xs={3}>
            <Field
              name="forename"
              component={TextField}
              label="Jméno"
              className={classes.textFields}
              validate={[required, maxLength64]}
            />
          </Grid>
          <Grid item xs={3}>
            <Field
              name="email"
              component={TextField}
              label="Email"
              className={classes.textFields}
              validate={[email, maxLength256]}
            />
          </Grid>
          <Grid item xs={3}>
            <Field
              name="phone"
              component={TextField}
              label="Telefon"
              className={classes.textFields}
              validate={[required, maxLengt16]}
            />
          </Grid>
          <Grid item xs={3}>
            <Field
              name="birthDate"
              component={TextField}
              label="Datum narození"
              type="date"
              className={classes.textFields}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
      </div>
    </FormSection>
    <div className={classes.section}>
      <Grid container spacing={8}>
        {userAttributes.map((item) => (
          <Grid key={item.id} item xs={3}>
            <FormControl className={classes.textFields}>
              <InputLabel htmlFor={item.name}>{item.name}</InputLabel>
              <Field name={`attributes.${item.id}`} component={Select} placeholder={item.name}>
                {item.values.map((item2) => (
                  <MenuItem key={item2.id} value={item2.id}>
                    {item2.value}
                  </MenuItem>
                ))}
              </Field>
            </FormControl>
          </Grid>
        ))}
      </Grid>
    </div>
    <div className={classes.section}>
      <FormSection name="address">
        <Grid container spacing={8}>
          <Grid item xs={3}>
            <Field
              name="street"
              component={TextField}
              label="Ulice"
              className={classes.textFields}
              validate={[required, maxLength64]}
            />
          </Grid>
          <Grid item xs={3}>
            <Field
              name="streetNumber"
              component={TextField}
              label="Číslo popisné"
              className={classes.textFields}
              validate={[required, maxLengt16]}
            />
          </Grid>
          <Grid item xs={3}>
            <Field
              name="city"
              component={TextField}
              label="Město"
              className={classes.textFields}
              validate={[required, maxLength64]}
            />
          </Grid>
          <Grid item xs={3}>
            <Field
              name="postalCode"
              component={TextField}
              label="Směrovací číslo"
              className={classes.textFields}
              validate={[required, number]}
            />
          </Grid>
        </Grid>
      </FormSection>
    </div>
    <FormSection name="identity">
      <Grid container spacing={8}>
        <Grid item xs={3}>
          <Field
            name="userIdNumber"
            component={TextField}
            label="Rodné číslo"
            className={classes.textFields}
            validate={[maxLength32]}
          />
        </Grid>
        <Grid item xs={3}>
          <FormControl className={classes.textFields}>
            <InputLabel htmlFor="typeId">Typ průkazu</InputLabel>
            <Field name="typeId" component={Select} placeholder="typeId" validate={[required]}>
              <MenuItem value="ID_CARD">Občanský průkaz</MenuItem>
              <MenuItem value="PASSPORT">Pas</MenuItem>
              <MenuItem value="DRIVER_LICENSE">Řidičský průkaz</MenuItem>
            </Field>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <Field
            name="serialNumber"
            component={TextField}
            label="Číslo průkazu"
            className={classes.textFields}
            validate={[required, maxLength32]}
          />
        </Grid>
        <Grid item xs={3}>
          <Field
            name="expiration"
            component={TextField}
            label="Platnost průkazu do"
            className={classes.textFields}
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
            validate={[required]}
          />
        </Grid>
      </Grid>
    </FormSection>
    <Grid container spacing={8} />
    <div style={{ marginTop: 20 }}>
      <Button type="submit" variant="contained" color="primary" className={classes.buttons}>
        Uložit
      </Button>
      {action === 'add' ? (
        <Button
          variant="contained"
          color="secondary"
          component={(props) => <Link to="/users/" {...props} />}
          className={classes.buttons}
        >
          Zrušit
        </Button>
      ) : (
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setEdit(false)}
          className={classes.buttons}
        >
          Zrušit
        </Button>
      )}
    </div>
  </form>
));



// WEBPACK FOOTER //
// ./src/modules/users/detail/userForm.js